import { useState, useEffect } from "react";
import { useAppNavigation } from "../../hooks/useAppNavigation";
import { getAllApps, subscribeToRegistry } from "../../utils/appRegistry";
import { AppIcon } from "../ui/AppIcon";
import { WebOSApp } from "../../types/webos";

export function ShellAppLauncher() {
  const { launchApp } = useAppNavigation();
  const [apps, setApps] = useState<WebOSApp[]>([]);

  // Subscribe to app registry changes
  useEffect(() => {
    const updateApps = () => {
      setApps(getAllApps());
    };

    // Initial load
    updateApps();

    // Subscribe to changes
    const unsubscribe = subscribeToRegistry(updateApps);

    return unsubscribe;
  }, []);

  const handleAppLaunch = (app: WebOSApp) => {
    launchApp(app);
  };

  return (
    <div className="webos-container">
      {/* Content Area */}
      <div className="launcher-container">
        {/* All Apps Section */}
        <div className="mb-4">
          {apps.length === 0 ? (
            <div className="empty-state">
              <div className="empty-state-icon">📱</div>
              <p className="empty-state-text">No apps installed</p>
            </div>
          ) : (
            <div className="apps-grid">
              {apps.map((app) => (
                <AppIcon
                  key={app.id}
                  app={app}
                  onClick={handleAppLaunch}
                  size="large"
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
